import type React from 'react';
import { usePageMaxWidth } from '../../../hooks/useLayoutWidth';
import { PAGE_WIDTHS, usePageGutter } from '../../layouts/PageContainer';

/**
 * The one page column every page with the shared place header uses — the
 * Accounts dashboard (All accounts and an account), a location's page, and
 * account and location settings — so breadcrumbs, title, tabs and content
 * start at the same x on all of them, and on the same edge as the top
 * navigation (HeaderContainer): the same gutter (16px phone, 20px wider) and
 * the same cap (none in full-width layout, the standard width in
 * comfortable layout). Vertical padding is the caller's.
 */
export function usePlacePageStyle(): React.CSSProperties {
  const maxWidth = usePageMaxWidth(PAGE_WIDTHS.standard);
  const gutter = usePageGutter();
  return { maxWidth, width: '100%', margin: '0 auto', boxSizing: 'border-box', paddingLeft: gutter, paddingRight: gutter };
}
